var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReduceOperation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2360_8717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.652 31.5854V31.6029H84.4464C82.5579 31.6029 81.0088 30.0538 81.0088 28.1646C81.0088 26.2753 82.5579 24.7263 84.4464 24.7263H103.214H104.464V23.4763V4.68829C104.464 2.79904 106.013 1.25 107.902 1.25C109.79 1.25 111.34 2.79905 111.34 4.68829V28.1471C111.34 30.0364 109.79 31.5854 107.902 31.5854H106.652Z",
    fill: "white",
    stroke: "#03AFB4",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0245 120.75H60.9913C45.0463 120.75 30.0476 114.555 18.7644 103.236L18.7618 103.233C7.44441 91.9483 1.25 76.9475 1.25 61C1.25 45.0525 7.44441 30.0517 18.7618 18.7669L18.7644 18.7642C30.0476 7.44523 45.0463 1.25 60.9913 1.25C80.6117 1.25 99.6738 10.8129 110.686 26.1402L110.69 26.146C111.807 27.6822 111.449 29.8286 109.891 30.9491L109.885 30.9531C108.35 32.0702 106.204 31.7123 105.084 30.1538C95.3044 16.547 78.415 8.144 60.9739 8.144C31.8265 8.144 8.10781 31.8664 8.10781 61.0174C8.10781 90.1685 31.8265 113.891 60.9739 113.891C90.1212 113.891 113.84 90.1685 113.84 61.0174C113.84 56.5572 113.287 52.1128 112.18 47.8089L112.178 47.8014C111.696 45.9738 112.812 44.0896 114.661 43.6144L114.669 43.6123C116.496 43.1301 118.38 44.246 118.855 46.0959L118.855 46.096C120.101 50.9427 120.733 55.9796 120.733 61.0349C120.733 76.9823 114.538 91.9831 103.221 103.268L103.219 103.269C92.4071 114.083 78.2103 120.237 63.0245 120.75Z",
    fill: "white",
    stroke: "#03AFB4",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4466 64.4383H70.3663C68.4778 64.4383 66.9287 62.8893 66.9287 61.0001C66.9287 59.1108 68.4778 57.5618 70.3663 57.5618H84.4466C86.3351 57.5618 87.8842 59.1108 87.8842 61.0001C87.8842 62.8893 86.3351 64.4383 84.4466 64.4383Z",
    fill: "white",
    stroke: "#03AFB4",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9913 55.0443H60.6457C58.9174 54.8692 57.5537 53.3961 57.5537 51.6235V23.4589C57.5537 21.5697 59.1028 20.0206 60.9913 20.0206C62.8799 20.0206 64.4289 21.5697 64.4289 23.4589V51.6061C64.4289 53.4953 62.8799 55.0443 60.9913 55.0443Z",
    fill: "white",
    stroke: "#03AFB4",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9914 73.8323C53.9099 73.8323 48.1611 68.083 48.1611 61C48.1611 53.9171 53.9099 48.1677 60.9914 48.1677C68.0729 48.1677 73.8217 53.9171 73.8217 61C73.8217 68.083 68.0729 73.8323 60.9914 73.8323ZM60.9914 55.0617C57.7218 55.0617 55.0538 57.7304 55.0538 61C55.0538 64.2696 57.7218 66.9383 60.9914 66.9383C64.261 66.9383 66.929 64.2696 66.929 61C66.929 57.7304 64.261 55.0617 60.9914 55.0617Z",
    fill: "white",
    stroke: "#03AFB4",
    strokeWidth: 2.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2360_8717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122,
    height: 122,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReduceOperation);
export default __webpack_public_path__ + "static/media/reduce-operation.757da2f86d91648536efc00c19e9cf44.svg";
export { ForwardRef as ReactComponent };